import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Paragraph from '../Paragraph/Paragraph';
import FundAccountSelect from '../FundAccountSelect/FundAccountSelect';
import { HeadingSubtitle } from '../Heading';
import Back from '../Buttons/Back';
import themeColors from '../../assets/styles/themeColors';

const SkipLink = styled.a`
  color: ${themeColors.colorLink};
  text-decoration: none;
  font-weight: 600;
  bottom: 60px;
  text-decoration: underline;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 900px) {
    margin: 0;
  }
`;

const SelectFundingMethod = ({
  handleNext,
  handleBack,
  nextPath,
  onModalClose,
  onSkip,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {handleBack && <Back onClick={handleBack} />}
      <HeadingSubtitle mb={12} color={themeColors.colorTextSecondary}>
        {t('fundAccount.normalTitle')}
      </HeadingSubtitle>
      <Paragraph mb={16} color={themeColors.colorTextXLLight}>
        {t('fundAccount.normalSubtitle')}
      </Paragraph>
      {onSkip && (
        <SkipLink data-cy="button-skip-funding" onClick={() => onSkip()}>
          {t('dolater')}
        </SkipLink>
      )}
      <FundAccountSelect
        handleNext={handleNext}
        nextPath={nextPath}
        onModalClose={onModalClose}
      />
    </>
  );
};

SelectFundingMethod.propTypes = {
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  nextPath: PropTypes.string,
  onModalClose: PropTypes.func,
  onSkip: PropTypes.func,
};

export default SelectFundingMethod;
